export default "__VITE_ASSET__D0a5UkPS__"